import { useEffect, useMemo, useRef, useState } from 'react';
import {
    MaterialReactTable,
    MRT_Cell,
    useMaterialReactTable,
    type MRT_ColumnDef,
    type MRT_TableOptions,
} from 'material-react-table';
import {
    Pagination,
    Typography,
    TextField,
    Button,
    Box,
    InputAdornment,
    useMediaQuery,
    PaginationItem,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Tabs,
    Tab,
    useTheme,
    Backdrop,
    CircularProgress
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg'
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg'
import add from 'packages/novous_web/src/assets/icons/add.svg'
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import play from 'packages/novous_web/src/assets/icons/Play.svg'
import dayjs, { Dayjs } from 'dayjs';
import { useToast } from 'packages/novous_web/src/context/ToastContext';
import { PageLoader } from 'packages/novous_web/src/common/components';
import { ArrowBack } from '@mui/icons-material';
import FilterVideosModal from './FilterVideosModal';
import LiveFeedModal from './LiveFeed';
import RequestVideoPlayback from './RequestVideoPlayback';
import Loader from 'packages/novous_web/src/common/components/Loader';
import { filterMarkersToPaddedViewport } from '@googlemaps/markerclusterer';


type ColumnObjType = {
    [key: string]: {
        name: string;
        status: boolean;
    };
};

interface Device {
    fleetId: string;
    requestId: string;
    deviceId: string;
    requestDate: string;
    vehicleId: string;
    vehicleName: string;
    clipStartRequestDate: string;
    clipEndRequestDate: string;
    showToUser: boolean;
    cameraName: string;
    status: string;
    sortkey: string;
}

const initialColumnObj = {}

const VideosDataTable: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState<Device[]>([])
    const [filteredData, setFilteredData] = useState<Device[]>([]);
    const isSmallScreen = useMediaQuery("(max-width:850px)");
    const [currentPage, setCurrentPage] = useState(1);
    const paginatedArr = useRef<any[]>([null]);
    const pageSize = 10;
    const { user } = useAuth();
    const navigate = useNavigate();
    const debouncedSearchQuery = useDebounce(searchQuery, 200);
    const { showToast } = useToast();
    const theme = useTheme();
    const [columnObj, setColumnObj] = useState<ColumnObjType>(initialColumnObj);
    const [isFilterModel, setIsFilterModelOpen] = useState(false);
    const [isRequestModal, setIsRequestModalOpen] = useState(false);
    const handleFilterClose = () => setIsFilterModelOpen(false);
    const handleFilterOpen = () => setIsFilterModelOpen(true);
    const [activeTab, setActiveTab] = useState(0);
    const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, tripId: "", vehicleId: "", deviceId: "", sortkey: "" });
    const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
    const [selected, setSelected] = useState(2);
    const [myData, setMyData] = useState("")
    const [myDeviceId, setMyDeviceId] = useState("")
    const [filterData, setFilterData] = useState(null);
    const [currentSortkey, setCurrentSortkey] = useState("");


    const {
        data: videosUrl,
        error: videosUrlError,
        loading: videosUrlLoading,
        fetchData: fetchVideosUrl,
    } = useAxios<any>(`${API_ENDPOINTS.directories.GET_VIDEOS_URL}`, "POST");
    // const {
    //     data: videosData,
    //     error: videosError,
    //     loading: videosLoading,
    //     fetchData: fetchVideosData,
    // } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_VIDEOS}`, "POST");

    const {
        data: filteredVideosData,
        error: filterVideosError,
        loading: filterVideosLoading,
        fetchData: fetchFilteredVideosData,
    } = useAxios<any>(`${API_ENDPOINTS.directories.FILTERED_VIDEOS}`, "POST");


    // Videos Playback Handler
    const handleLiveFeedClose = () => {
        setIsLiveFeedOpen({ isOpen: false, tripId: "", vehicleId: "", deviceId: "", sortkey: "" });
        setSelected(2);
        setMyData("");
        setMyDeviceId("");
    };

    const handleFatchVideoUrl = (vehicleId: string, requestId: string, deviceId: string, sortkey: string) => {
        fetchVideosUrl({
            vehicleId: vehicleId,
            requestId: requestId,
            fleetId: user?.customer_id,
            deviceId: deviceId,
            sortkey: sortkey
        })
        setMyData(vehicleId)
        setMyDeviceId(deviceId);
        setCurrentSortkey(sortkey)
    }


    // Open the LiveFeedModal and process the videoUrls for the clicked alert
    const handleOpenLiveFeed = (vehicleId: string, videoUrls: string, deviceId?: string, sortkey?: string, cameraKey?: string) => {
        setIsLiveFeedOpen({ isOpen: true, tripId: vehicleId, vehicleId: vehicleId, deviceId: deviceId || "", sortkey: sortkey || "" });
        const fileName = videoUrls.split("/").pop()?.split("?")[0] || "";
        const segments = fileName.split("_");
        const cameraCode = segments[1] || 'Unknown';
        const cameraMapping: Record<string, string> = {
            "01": "ADAS",
            "02": "CAM3",
            "03": "CAM4",
            "04": "DMS",
        };
        const arr = Object.entries(cameraMapping)
        const ck = cameraKey === 'FCW' ? 'ADAS' :
            cameraKey === 'DSM' ? 'CAM3' :
                cameraKey === 'REAR_CAMERA' ? 'CAM4' :
                    cameraKey === 'IN_CABIN' ? 'DMS' :
                        cameraKey;

        const value = arr.find((item) => item[1] === ck);

        const cameraId = value ? value[0] : cameraMapping[cameraCode];
        const cameraName = cameraMapping[cameraId] || "Unknown";
        let newUrl = { cameraId, cameraName, playBackUrl: videoUrls };
        setLiveFeedCameraInfo([newUrl]);
        setSelected(0);
    };
    useEffect(() => {
        if (myData && videosUrl?.data || myDeviceId) {
            const keys = Object.keys(videosUrl?.data);
            if (keys.length > 0) {
                const videoUrls = videosUrl?.data[keys[0]];
                handleOpenLiveFeed(myData, videoUrls, myDeviceId, currentSortkey, keys[0]);
            }
        }
    }, [videosUrl?.data])

    useEffect(() => {
        if (filterVideosError || videosUrlError) {
            showToast(filterVideosError || videosUrlError || "Something went wrong!", "error")
        }
    }, [filterVideosError, videosUrlError])

    function combineDateTime(dateStr: any, timeStr: any) {
        // Parse date (assuming format DD/MM/YYYY)
        const [day, month, year] = dateStr.split('/');

        // Parse time (assuming format "HH:mm AM/PM")
        const [time, period] = timeStr.split(' ');
        let [hours, minutes] = time.split(':');

        // Convert to 24-hour format
        hours = parseInt(hours, 10);
        if (period === 'PM' && hours !== 12) hours += 12;
        if (period === 'AM' && hours === 12) hours = 0;

        // Construct ISO string (YYYY-MM-DDTHH:mm:ss)
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
    }

    useEffect(() => {
        if (filteredVideosData) {
            console.log(filteredVideosData, 'filteredVideosData----------------');
            if (filteredVideosData?.data) {
                const deviceListData: Device[] = filteredVideosData?.data?.videoOnDemandRequestEntityList?.map((device: any) => ({
                    deviceId: device.deviceId,
                    requestDate: device.requestDate,
                    vehicleId: device.vehicleId || "N/A",
                    vehicleName: device.vehicleName || "N/A",
                    clipStartRequestDate: device.clipStartRequestDate || "N/A",
                    clipEndRequestDate: device.clipEndRequestDate || "N/A",
                    showToUser: device.showToUser,
                    cameraName: device?.cameraName,
                    status: device?.status,
                    ...device
                }));
                setData(deviceListData)
            }
        }

    }, [filteredVideosData])

    // Filter Handler
    const handleFilterSave = (filters: any) => {
        console.log('filters', filters);
        paginatedArr.current = [null];
        setCurrentPage(1);
        if (filters?.vehicleId || filters?.startDate || filters?.endDate || filters?.startTime || filters?.endTime) {
            setFilterData(filters);
            setCurrentPage(1);
            fetchFilteredVideosData({
                vehicleId: filters?.vehicleId || null,
                startDateTime: filters?.startDate ? combineDateTime(filters.startDate, filters.startTime) : null,
                endDateTime: filters?.endDate ? combineDateTime(filters.endDate, filters.endTime) : null,
                tab: (activeTab === 1) ? 'PROCESSING' : 'FAILED',
                fleetId: user?.customer_id,
            })
        } else {
            setFilterData(null);
            fetchFilteredVideosData({

                tab: (activeTab === 1) ? 'PROCESSING' : 'FAILED',
                fleetId: user?.customer_id,
            })
        }
    };

    useEffect(() => {
        if (filterData) {
            const filterResults = (dataList: any[], filters: any) => {
                return dataList?.filter(item => {
                    // Step 1: Parse the item's full datetime
                    const itemStart = dayjs(item.clipStartRequestDate, "YYYY-MM-DD HH:mm:ss");

                    // Step 2: Parse startDateTime from filters
                    let startDateTime: Dayjs | null = null;
                    if (filters?.startDate) {
                        const startDateStr = filters.startDate; // e.g. "18/03/2025"
                        const startTimeStr = filters.startTime || "00:00 AM"; // default to midnight
                        startDateTime = dayjs(`${startDateStr} ${startTimeStr}`, "DD/MM/YYYY hh:mm A");
                    }

                    // Step 3: Parse endDateTime from filters
                    let endDateTime: Dayjs | null = null;
                    if (filters?.endDate) {
                        const endDateStr = filters.endDate;
                        const endTimeStr = filters.endTime || "11:59 PM"; // default to end of day
                        endDateTime = dayjs(`${endDateStr} ${endTimeStr}`, "DD/MM/YYYY hh:mm A");
                    }

                    // Step 4: Apply datetime and vehicleId filters
                    const isAfterStart = startDateTime ? itemStart.isSame(startDateTime) || itemStart.isAfter(startDateTime) : true;
                    const isBeforeEnd = endDateTime ? itemStart.isSame(endDateTime) || itemStart.isBefore(endDateTime) : true;
                    const matchesVehicleId = filters?.vehicleId ? item.vehicleId === filters.vehicleId : true;

                    return matchesVehicleId && isAfterStart && isBeforeEnd;
                });
            };
            console.log('filterData', filterData);


            const results = filterResults(filteredVideosData?.data?.videoOnDemandRequestEntityList || [], filterData);
            setFilteredData(results);
        } else {
            setFilteredData(filteredVideosData?.data?.videoOnDemandRequestEntityList || []);
        }
    }, [filterData]);


    useEffect(() => {


        fetchFilteredVideosData({
            fleetId: user?.customer_id,
            tab: (activeTab === 1) ? 'PROCESSING' : 'FAILED',
        })

        // fetchVideosData({
        //     fleetId: user?.customer_id,
        //     tripRequest: false,
        //     requestDate: dayjs().format("YYYY-MM-DD")
        // });
    }, [user?.customer_id, isRequestModal]);
    useEffect(() => {
        console.log(filteredVideosData, 'filteredVideosData----------------');

        if (filteredVideosData?.data) {
            const deviceListData: Device[] = filteredVideosData?.data?.videoOnDemandRequestEntityList.map((device: any) => ({
                deviceId: device.deviceId,
                requestDate: device.requestDate,
                vehicleId: device.vehicleId || "N/A",
                vehicleName: device.vehicleName || "N/A",
                clipStartRequestDate: device.clipStartRequestDate || "N/A",
                clipEndRequestDate: device.clipEndRequestDate || "N/A",
                showToUser: device.showToUser,
                cameraName: device?.cameraName,
                status: device?.status,
                ...device
            }));
            setData(deviceListData)
        }
        if (filteredVideosData?.data?.lastEvaluatedKey) {
            if (paginatedArr.current.length === currentPage) {
                paginatedArr.current.push(filteredVideosData.data.lastEvaluatedKey);
            }
        }
    }, [filteredVideosData])

    useEffect(() => {
        if (filteredVideosData?.data?.lastEvaluatedKey) {
            console.log('filteredVideosData?.data?.lastEvaluatedKey', paginatedArr.current.length, currentPage);

            if (paginatedArr.current.length === currentPage) {
                paginatedArr.current.push(filteredVideosData.data.lastEvaluatedKey);
            }
        }
    }, [filteredVideosData]);


    //  Search option
    useEffect(() => {
        if (debouncedSearchQuery) {
            const filteredDataArr = data?.filter(
                (item) =>
                (
                    item.vehicleId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    item.vehicleName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    item.cameraName?.toLowerCase().includes(searchQuery.toLowerCase())

                )
            );
            setFilteredData(filteredDataArr)
        } else {
            setFilteredData(data)
        }
    }, [debouncedSearchQuery, data])


    // Faulty filter handler
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        if (newValue === 1) {
            fetchFilteredVideosData({
                fleetId: user?.customer_id,
                tab: (newValue === 1) ? 'PROCESSING' : 'FAILED',
            })

            // setFilteredData(data)
        } else {
            fetchFilteredVideosData({
                fleetId: user?.customer_id,
                tab: (newValue === 1) ? 'PROCESSING' : 'FAILED',
            })
        }
    };






    const handlePageChange = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        if (page !== 1) {
            if (filterData) {
                handleFilterSave(filterData);
            }
            else {
                fetchFilteredVideosData({
                    fleetId: user?.customer_id,
                    tab: (activeTab === 1) ? 'PROCESSING' : 'FAILED',
                    lastEvaluatedKey: paginatedArr.current[page - 1],
                });
            }
        } else {
            if (filterData) {
                handleFilterSave(filterData);
            }
            else {
                fetchFilteredVideosData({
                    fleetId: user?.customer_id,
                    tab: (activeTab === 1) ? 'PROCESSING' : 'FAILED',
                })
            }

        }
        setCurrentPage(page);
    };


    // Table Option ---------------
    const allColumns: MRT_ColumnDef<Device>[] = useMemo(() => {
        return [
            {
                accessorKey: 'vehicleId',
                header: 'Vehicle Reg No.',
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                muiTableBodyCellProps: {
                    sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
                },
                Cell: ({ cell }) => (
                    <Typography variant="body2" fontWeight={400} noWrap>
                        {cell.getValue<string>()}
                    </Typography>
                ),
            },
            {
                accessorKey: 'vehicleName',
                header: 'Vehicle Name',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ cell }) => (
                    <Typography variant="body2" fontWeight={400} noWrap>
                        {cell.getValue<string>() || "N/A"}
                    </Typography>
                ),
            },
            {
                accessorKey: 'cameraName',
                header: 'Camera Name',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ cell }) => (
                    <Typography variant="body2" fontWeight={400} noWrap>
                        {cell.getValue<string>() || "N/A"}
                    </Typography>
                ),
            },
            {
                accessorKey: 'requestDate',
                header: 'Requested on',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ cell }) => (
                    <Typography variant="body2" fontWeight={400} noWrap>
                        {dayjs(cell.getValue<string>()).format("DD MMM, YYYY")}
                    </Typography>
                ),
            },
            {
                accessorKey: 'clipStartRequestDate',
                header: 'Footage Date',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ cell }) => (
                    <Typography variant="body2" fontWeight={400} noWrap>
                        {dayjs(cell.getValue<string>()).format("DD MMM, YYYY")}
                    </Typography>
                ),

            },
            {
                accessorKey: 'clipEndRequestDate',
                header: 'Footage Duration',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ row }) => {
                    let startDate = row?.original?.clipStartRequestDate.replace(":", " "); // Fix incorrect format
                    let endDate = row?.original?.clipEndRequestDate.replace(":", " "); // Fix incorrect format

                    let formattedStart = dayjs(startDate, "YYYY-MM-DD HH:mm:ss").format("hh:mm:ss A");
                    let formattedEnd = dayjs(endDate, "YYYY-MM-DD HH:mm:ss").format("hh:mm:ss A");
                    return (
                        <Typography
                            variant="body2"
                            fontWeight={400}
                            sx={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                            }}
                        >
                            {`${formattedStart} - ${formattedEnd}`}
                        </Typography>
                    )

                },
            },
            {
                accessorKey: 'status',
                header: 'Status',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ cell }) => {
                    const status = cell.getValue();
                    let backgroundColor;
                    let color = "#219653";
                    console.log("status", status);
                    switch (status) {
                        case "AVAILABLE":
                            backgroundColor = '#27AE6026';
                            color = "#219653"
                            break;
                        case "FAILED":
                            backgroundColor = '#FFCDD2';
                            color = "#C62828"
                            break;

                        default:
                            backgroundColor = '#FBF1D2';
                            color = "#A9861E"
                    }

                    return (
                        <div
                            style={{
                                backgroundColor: backgroundColor,
                                padding: '4px 8px',
                                borderRadius: '12px',
                                display: 'inline-block',
                                minWidth: '80px',
                                textAlign: 'center',
                                lineHeight: "18px",
                                color: color
                            }}
                        >
                            <Typography variant="body2" fontWeight={500}>
                                {status === "FAILED" ? "Failed" : status === "AVAILABLE" ? "Available" : "Processing"}
                            </Typography>
                        </div>
                    );
                }
            },
            {
                accessorKey: 'actions',
                header: 'Actions',
                muiTableBodyCellProps: {
                    sx: {
                        padding: '8px',
                    },
                },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ row }) => (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        {row?.original?.showToUser &&
                            <IconButton
                                sx={{
                                    padding: 1,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    },
                                }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    console.log('IconButton clicked');
                                    if (row.original) {
                                        handleFatchVideoUrl(row.original?.vehicleId, row.original?.requestId, row.original?.deviceId, row.original?.sortkey);
                                    } else {
                                        console.error('Row data is undefined');
                                    }
                                }}
                            >
                                <img
                                    src={play}
                                    alt="custom action"
                                    width={24}
                                    height={24}
                                />
                            </IconButton>}
                    </Box>
                ),
            },


        ];
    }, [isSmallScreen]);


    const columns: MRT_ColumnDef<Device>[] = useMemo(() => {
        return allColumns?.filter((column) => {
            const key = column.accessorKey as keyof ColumnObjType;
            return columnObj[key]?.status;
        });
    }, [allColumns, columnObj]);

    const totalPages = paginatedArr.current.length;


    // Table options
    const tableOptions: MRT_TableOptions<Device> = {
        columns: allColumns,
        data: filteredData,
        enablePagination: false,
        enableColumnFilters: false,
        enableSorting: false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableHiding: false,
        enableBottomToolbar: false,
        enableTopToolbar: false,
        enableFullScreenToggle: false,
        enableColumnResizing: false,
        enableToolbarInternalActions: false,
        initialState: {
            columnPinning: {
                left: ['deviceCode', 'deviceName'],
                right: ['actions'],
            },
        },
        muiTableBodyProps: {
            sx: {
                padding: 0,
                margin: 0,
            },
        },
    };
    const table = useMaterialReactTable(tableOptions);


    return (
        <>
            <div className='flex flex-col gap-4 w-full'>
                <div className="mb-4">
                    <button className="text-blue-600 font-medium flex items-center" onClick={() => navigate(-1)}>
                        <ArrowBack className="mr-1" /> Back
                    </button>
                </div>
                {/* Search Input */}
                <div className=' w-full flex justify-between gap-4 xs:flex-col '>

                    <Typography variant="h5" fontWeight={600}>
                        Video Playback
                    </Typography>
                    <div className="flex gap-4 flex-wrap">
                        {filterData && <CustomIconButton
                            text={`Clear Filters (${Object.values(filterData)?.filter(value => value !== null).length})`}
                            background='transparent'
                            outline={false} // Set to true if you want an outline
                            textColor="#C83333"
                            onClick={() => {
                                handleFilterSave(null);
                                setCurrentPage(1);
                            }}
                        />}
                        <div className="max-w-[400px]">
                            <TextField
                                variant="outlined"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search"
                                sx={(theme) => ({
                                    "& .MuiOutlinedInput-root": {
                                        borderColor: theme.palette.action.selected,
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%", // Ensure it takes full available height
                                    },
                                    "& .MuiInputBase-root": {
                                        padding: '0rem 1rem'
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        padding: "0px 12px", // Adjust padding for better spacing
                                        height: '48px',
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                    width: {
                                        xs: '100%',     // full width on extra small screens
                                        sm: '300px',    // 300px on small screens
                                        md: '400px',    // 400px on medium and up
                                    },
                                })}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={searchIcon} alt="icon" width={16} height={16} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            sx={(theme) => ({
                                                height: "48px", // Ensure full height
                                                maxHeight: '48px',
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: 'pointer',
                                                borderLeft: `1px solid ${theme.palette.action.selected}`,
                                                paddingLeft: "8px",
                                            })}
                                        >
                                            <img src={filterIcon} onClick={handleFilterOpen} alt="icon" width={24}
                                                height={24} />
                                        </InputAdornment>
                                    ),
                                }}
                                inputProps={{
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "14px", // You can adjust this as per Typography variant
                                        fontWeight: 500, // Normal text weight
                                    },
                                }}
                            />
                        </div>


                        <CustomIconButton
                            // icon={<img src={add} alt="Add" width={16} height={16} />}
                            text="Request Video"
                            variant='contained'
                            onClick={() => setIsRequestModalOpen(true)}
                        />
                    </div>
                </div>
                <Box className="flex items-center w-full justify-between">
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{
                            borderRadius: "8px",
                            padding: "4px",
                            backgroundColor: theme.palette.selected,
                        }}
                        TabIndicatorProps={{ style: { display: "none" } }}
                    >
                        <Tab
                            label="All Videos"
                            sx={{
                                ...(activeTab === 0
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        padding: "8px 16px",
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                        <Tab
                            label="Requested Videos"
                            sx={{
                                ...(activeTab === 1
                                    ? {
                                        backgroundColor: theme.palette.background.default,
                                        color: theme.palette.primary.main,
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        padding: "8px 16px",
                                        boxShadow: "0px 4px 6px #5547DD1A",
                                    }
                                    : { color: theme.palette.text.primary }),
                            }}
                        />
                    </Tabs>

                </Box>
                {!filterVideosLoading ? <MaterialReactTable
                    table={table}
                />
                    : <PageLoader />
                }
                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        shape="rounded"
                        color="primary"
                        siblingCount={0}
                        boundaryCount={0}
                        renderItem={(item) => {
                            if (
                                item.type === "page" &&
                                item.page !== null &&
                                item.page > currentPage
                            ) {
                                return null;
                            }
                            return <PaginationItem {...item} />;
                        }}
                    />
                </Box>
            </div>


            <FilterVideosModal
                open={isFilterModel}
                onClose={handleFilterClose}
                handleFilterSave={handleFilterSave}
                title={`Filters (${filteredVideosData?.data?.length} playbacks)`}
                description="Select a date and time range to view the video playbacks achieved during that period."
                data={filteredVideosData?.data}
            />
            <RequestVideoPlayback
                open={isRequestModal}
                onClose={() => setIsRequestModalOpen(false)}
                title='Request Video Playback'
                description="Select a vehicle and specify the date and time range to retrieve the required video footage."
            />
            <LiveFeedModal
                type="alert"
                alertName="Video Playback"
                selectedCamera={selected}
                trip={isLiveFeedOpen}
                cameraInfo={liveFeedCameraInfo}
                isDash={true}
                open={isLiveFeedOpen.isOpen}
                onClose={handleLiveFeedClose}
                deviceId={isLiveFeedOpen.deviceId}
                videoPlayback={true}
            />


            {videosUrlLoading && (
                <Loader />
            )}
        </>
    );
}

export default VideosDataTable